/*
 * Created by guandong.ni on 17/10/27.
 * 通用loading蒙层
 */
export default {
  show(){
    if (!this.o) {
      require('./assets/css/loading.css');
      this.o = $('<div class="loading ani_opacity"><i>正在加载</i></div>').appendTo('body');
    }
    this.o.show();
  },
  hide(){
    this.o.hide();
  },
};



// WEBPACK FOOTER //
// ./src/component/common/loading.jquery.js